import { Component, OnInit, OnDestroy, input } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { AssignedToComponent } from '@fitness-force/common/assigned-to';
import { TranslateModule } from '@ngx-translate/core';
import { CONSTANTS_CRM } from '@fitness-force/constants';
import { WalkInTrialComponent } from '../walk-in-trial/walk-in-trial.component';
import { ErrorMsgComponent } from '@fitness-force/errors';;

@Component({
  selector: 'walk-in-tour',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    DatePickerModule,
    SelectModule,
    InputTextModule,
    AssignedToComponent,
    WalkInTrialComponent,
    TranslateModule,
    ErrorMsgComponent,
    AsyncPipe
],
  templateUrl: './walk-in-tour.component.html'
})
export class WalkInTourComponent implements OnInit, OnDestroy {
  readonly parentForm = input.required<FormGroup>();
  readonly staffList = input<any[]>([]);

  private destroy$ = new Subject<void>();
  tourOutcomes = CONSTANTS_CRM.TOUR_OUTCOME;
  maxDate = new Date();
  assignedTo$ = new BehaviorSubject<number>(0);
  

  ngOnInit() {
    // Set validators for required fields
    const parentForm = this.parentForm();
    if(parentForm.get('createWalkInTour')?.value) {
      // Create tour_completed form group if it doesn't exist
      if (!parentForm.contains('tour_completed')) {
        const tourCompletedGroup = new FormGroup({
          tour_outcome: new FormControl(null, [Validators.required]),
          notes: new FormControl(null, [Validators.required]),
          scheduled_datetime: new FormControl(new Date(), [Validators.required]),
          assigned_to_staff_id: new FormControl(null, [Validators.required])
        });

        parentForm.addControl('tour_completed', tourCompletedGroup);
        parentForm.updateValueAndValidity();
      }
    }

    // Subscribe to createWalkInTour changes
    parentForm.get('createWalkInTour')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(createTour => {
        if (createTour) {
          this.updateValidation();
        } else {
          this.clearValidation();
        }
      });

      parentForm.get('tour_completed.tour_outcome')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(outcome => {
        const parentFormValue = this.parentForm();
        if (parentFormValue.contains('trial_membership')) {
          parentFormValue.get('trial_membership')?.clearValidators();
          parentFormValue.get('trial_membership')?.updateValueAndValidity({ emitEvent: false });
        }
        // Check if trial_classes control exists, if not create it
        if (parentFormValue.contains('trial_classes')) {
          parentFormValue.get('trial_classes')?.clearValidators();
          parentFormValue.get('trial_classes')?.updateValueAndValidity({ emitEvent: false });
        }
        parentFormValue.updateValueAndValidity();
        if (outcome && outcome.shortname === 'booktrial') {

          parentFormValue.get('tour_completed.notes')?.clearValidators();
          parentFormValue.get('tour_completed.notes')?.updateValueAndValidity({ emitEvent: false });
          
        }
        else{
          parentFormValue.get('tour_completed.notes')?.setValidators([Validators.required]);
          parentFormValue.get('tour_completed.notes')?.updateValueAndValidity({ emitEvent: false });
        }
      });
  }

  private updateValidation() {
    const tourCompletedGroup = this.parentForm().get('tour_completed') as FormGroup;
    if (tourCompletedGroup) {
      Object.keys(tourCompletedGroup.controls).forEach(key => {
        const control = tourCompletedGroup.get(key);
        if (control) {
          control.setValidators([Validators.required]);
          control.updateValueAndValidity({ emitEvent: false });
        }
      });
    }
  }

  private clearValidation() {
    const tourCompletedGroup = this.parentForm().get('tour_completed') as FormGroup;
    if (tourCompletedGroup) {
      Object.keys(tourCompletedGroup.controls).forEach(key => {
        const control = tourCompletedGroup.get(key);
        if (control) {
          control.clearValidators();
          control.updateValueAndValidity({ emitEvent: false });
        }
      });
    }
  }

  getSelectedStaff(event: any) {
    console.log(event);
    this.parentForm().get('assigned_to_staff_id')?.setValue(event.id);
  }

  get assignedToFormControl() {
    return this.parentForm().get('tour_completed.assigned_to_staff_id')!;
  }

  get selectedOutcomeFormControl() {
    return this.parentForm().get('tour_completed.tour_outcome')!;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
} 